const ROOT = 'CipReport/filter/validationDateRange'

export const SET_START_DATE_ERROR_MESSAGE = `${ROOT}/SET_START_DATE_ERROR_MESSAGE`;
export const SET_END_DATE_ERROR_MESSAGE = `${ROOT}/SET_END_DATE_ERROR_MESSAGE`;
